import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  UrlModule,
  provideDefaultConfig,
  ConfigModule,
} from '@spartacus/core'

import { AddToCartComponent } from './add-to-cart.component'
import { AddedToCartDialogComponent } from './added-to-cart-dialog/added-to-cart-dialog.component'
import {
  SpinnerModule,
  IconModule,
  KeyboardFocusModule,
  MediaModule,
  DIALOG_TYPE,
} from '@spartacus/storefront'
import { GetAQuoteDialogComponent } from '../get-a-quote-dialog/get-a-quote-dialog.component'
import { AddBomToCartComponent } from '../add-bom-to-cart/add-bom-to-cart.component'
import { AddBomToQuoteCartComponent } from '../add-bom-to-quote-cart/add-bom-to-quote-cart.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { CartSharedModule } from '../cart-shared/cart-shared.module'
import { ItemCounterModule } from '../../../shared/directive/item-counter/item-counter.module'
import { DatePickerModule } from '../../../shared/components/date-picker/date-picker.module'
import { environment } from '../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CartSharedModule,
    RouterModule,
    SpinnerModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    KeyboardFocusModule,
    MediaModule,
    FormsModule,
    NgSelectModule,
    DatePickerModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['addCart'],
        },
      },
    }),
  ],
  providers: [
    OccCartAdapter,
    provideDefaultConfig({
      cmsComponents: {
        ProductAddToCartComponent: {
          component: AddToCartComponent,
        },
      },
    } as CmsConfig),
    provideDefaultConfig({
      launch: {
        [VS_LAUNCH_CALLER.ADD_TO_CART]: {
          inlineRoot: true,
          component: AddedToCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.GET_A_QUOTE]: {
          inlineRoot: true,
          component: GetAQuoteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.ADD_BOM_TO_CART]: {
          inlineRoot: true,
          component: AddBomToCartComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.ADD_BOM_TO_QUOTE_CART]: {
          inlineRoot: true,
          component: AddBomToQuoteCartComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  declarations: [
    AddToCartComponent,
    AddedToCartDialogComponent,
    GetAQuoteDialogComponent,
    AddBomToCartComponent,
    AddBomToQuoteCartComponent,
  ],
  exports: [
    AddToCartComponent,
    AddedToCartDialogComponent,
    GetAQuoteDialogComponent,
  ],
})
export class AddToCartModule {}
